import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-promotion-settings',
  templateUrl: './promotion-settings.component.html',
  styleUrls: ['./promotion-settings.component.scss']
})
export class PromotionSettingsComponent implements OnInit {

  partner = '';
  account = '';
  userSearch = '';
  apiSearch = '';

  users: any = {
    name: '',
    completed: false,
    color: 'primary',
    subtasks: []
  };
  allUsersSelected: boolean;
  usersSelected: boolean;
  overrideAPIs = [];
  apiDependenciesList: any;
  allChecked = false;
  navItems: any;
  overrideAPI: boolean;
  componentLoading = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<PromotionSettingsComponent>) { }

  ngOnInit() {

    setTimeout(() => {
      this.componentLoading = false;
      this.users = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
      };
      this.navItems = this.data.navItems;
      this.users = this.data.users;
      this.userSelection();
      if (this.data['type'] === 'master') {
        this.overrideAPIs = this.data.overrideAPIs;
        this.apiDependenciesList = this.data.apiDependenciesList;
        this.allChecked = this.data.allChecked;
      }
    }, 500);

    // else {
    //   this.overrideAPI = this.data.overrideAPI;
    // }
  }

  userSelection() {
    const tempUsersSelected = this.users.subtasks.filter(t => t.completed).length;
    this.allUsersSelected = this.users.subtasks != null && tempUsersSelected === this.users.subtasks.length;
    this.usersSelected = this.users.subtasks != null && tempUsersSelected > 0;
  }

  setOverrideAPI(checked) {
    this.overrideAPI = checked;
  }

  addOverrideAPI(index, checked) {
    if (checked) {
      if (!this.overrideAPIs.includes(index)) {
        this.overrideAPIs.  push(index);
      }
    } else {
      if (this.overrideAPIs.includes(index)) {
        const index2 = this.overrideAPIs.indexOf(index, 0);
        if (index > -1) {
          this.overrideAPIs.splice(index2, 1);
        }
      }
    }
    this.setOverrideForAPI(this.getApiNameAndVersion(this.apiDependenciesList[index]), index, checked);
  }

  setOverrideForAPI(displayName, index, checked) {
    if (index === 0) {
      this.navItems[0].override = checked;
    } else {
      const childIndex = this.navItems[0].children.findIndex(value => value['displayName'] === displayName);
      this.navItems[0].children[childIndex].override = checked;
    }
  }

  setOverrideForIndividualAPI(displayName, index, checked) {
    if (index === 0) {
      this.navItems.override = checked;
    } else {
      const childIndex = this.navItems.children.findIndex(value => value['displayName'] === displayName);
      this.navItems.children[childIndex].override = checked;
    }
  }

  getApiNameAndVersion(api) {
    if (api.hasOwnProperty('entityname') && api.hasOwnProperty('version')) {
      return api.entityname + ' (' + api.version + ')';
    } else {
      return api.executor_name + ' (' + api.executor_version + ')';
    }
  }


  someCompleteParent(type) {
    //this.selectedAPIs = [];
    return this.someComplete2(type);
  }

  someSelected(): boolean {
    return this.overrideAPIs.length > 0 && this.overrideAPIs.length < this.apiDependenciesList.length;
  }

  someComplete(): boolean {
    if (this.users.subtasks == null) {
      return false;
    }
    return this.users.subtasks.filter(t => t.completed).length > 0 && !this.allUsersSelected;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  setAllUsers(completed: boolean) {
    this.allUsersSelected = completed;
    if (this.users.subtasks == null) {
      return;
    }
    this.users.subtasks.filter(function (e) {
      if (!e.preSelected) {
        e.completed = completed;
      }
    });
  }

  someComplete2(type, item = this.navItems[0]): boolean {
    if (!item[type]) {
      if (item.children && item.children.length) {
        let completedChildren = 0;
        for (const child of item.children) {
          if (this.someComplete2(type, child)) {
            completedChildren++;
            return true;
          }
        }
        // return (completedChildren === item.children.length) ? true : false;
      } else {
        return false;
      }
    } else {
      return true && !this.allChecked;
    }
  }

  setAllParent(checked, type) {
    // if (type === 'override' && checked) {
      this.overrideAPIs = [];
    // }
    this.setAll(checked, type);
  }

  setAll(checked: boolean, type, item = this.navItems[0]) {
    this.allChecked = checked;
    item[type] = checked;
    if (type === 'override' && checked) {
      this.overrideAPIs.push(item.index);
    }
    if (item.children && item.children.length) {
      for (const child of item.children) {
        this.setAll(checked, type, child);
      }
    }
  }

}
